import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Typography } from "@launchmetrics/lm-ui";
import { Select, SelectOption } from '@launchmetrics/lm-ui';
import { State } from "store/types";

import { FeedClippingCount, removeReportClipping, setReportClipping } from "store/article/report/reducers";

import { Language } from "./fields/common/Language";
import { Currency } from "./fields/common/Currency";
import { GroupLocation } from "./fields/common/GroupLocation";
import { PLACEMENTS_COUNT } from "./fields/consts";

export const Online: React.FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const feedClippings = useSelector((state: State) => state.article.report.configuration.definition.feedClippings);

	const isSelected = useCallback((count: number) => {
		if (!feedClippings || !feedClippings.length) return false;
		return feedClippings[0].count === count;
	}, [feedClippings]);

	useEffect(() => {
		dispatch(setReportClipping({feedId: "all", count: 10 as FeedClippingCount}));
		return () => {
			dispatch(removeReportClipping({feedId: "all"}));
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className='side-panel-content-entry'>
				<div><Typography variant='textSmBold'>{t('reports.groups')}</Typography></div>
				<GroupLocation />
			</div>

			<div className='side-panel-content-entry'>
				<div><Typography variant='textSmBold'>{t('reports.settings')}</Typography></div>
				<Language />
				<Currency />
			</div>

			<div className='side-panel-content-entry'>
				<div><Typography variant='textSmBold'>{t('reports.content')}</Typography></div>
				<div className='side-panel-content-entry-element'>
					<div>
						<Select placeholder={t('reports.content_text') as string}>
							{PLACEMENTS_COUNT.map((count, index) => (
								<SelectOption
									selected={isSelected(count)}
									onClick={() => dispatch(setReportClipping({feedId: "all", count: count as FeedClippingCount}))}
									key={index}
									optionValue={{ key: count.toString(), value: t('reports.feeds.first_number_placements', { count }) as string }}
								/>
							))}
						</Select>
					</div>
				</div>
			</div>
		</>
	);
};
